import { C as o, H as i } from "./styled-components.browser.esm-CdvvWRMU.js";
const s = {
  lg: o`
    height: ${(e) => e.theme.spacingInlineLgRem};
  `,
  md: o`
    height: ${(e) => e.theme.spacingInlineMdRem};
  `,
  sm: o`
    height: ${(e) => e.theme.spacingInlineSmRem};
  `
}, c = {
  lg: o`
    font-size: ${(e) => e.theme.fontSizeXxxs};
  `,
  md: o`
    font-size: ${(e) => e.theme.fontSizeXxxs};
  `,
  sm: o`
    font-size: ${(e) => e.theme.fontSizeNano};
  `
}, d = {
  left: o`
    justify-content: end;
  `,
  right: o`
    margin-left: auto;
    justify-content: start;
  `
}, a = "md", n = i.input`
  display: block;
  flex: 1;
  height: 100%;
  width: 100%;
  outline: none;
  border: none;
  color: ${(e) => e.theme.colorSupportTextDarkest};
  line-height: ${(e) => e.theme.lineHeightFair};
  ${(e) => c[e.inputSize || a]}
  position: absolute;
  left: 0;
  padding: 0 ${(e) => e.theme.spacingInlineXxxsRem};

  ${(e) => e.hasSuffix && o`
      padding-right: ${(r) => r.theme.spacingInlineSmRem};
    `}

  ${(e) => e.hasPrefix && o`
      padding-left: ${(r) => r.theme.spacingInlineSmRem};
    `}


  &:disabled {
    cursor: not-allowed;
  }

  &[type='password']::-ms-reveal,
  &[type='password']::-ms-clear,
  &[type='password']::-ms-reveal {
    display: none;
  }

  &[type='search']::-webkit-search-cancel-button {
    display: none;
  }
`, l = i.div`
  display: flex;
  align-items: center;
  background: transparent;
  cursor: normal;
  height: 100%;
  position: relative;
  z-index: 1;
  color: ${(e) => e.theme.colorNeutralDark};
  width: ${(e) => e.theme.spacingInsetLgRem};
  ${({ position: e }) => d[e || "left"]}

  &:hover {
    color: ${(e) => e.theme.colorSupportTextDarkest};
  }
`, h = i.div`
  position: relative;
  overflow: hidden;
  display: flex;
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  width: 100%;
  border-radius: ${(e) => e.theme.borderRadiusMd};
  background-color: ${(e) => e.theme.colorNeutralSnow};
  border: ${(e) => e.theme.borderWidthHairline} solid ${(e) => e.theme.colorDisabledDark};

  ${(e) => s[e.inputSize || a]}

  ${({ isDisabled: e, theme: r }) => e ? o`
          cursor: not-allowed;
          color: ${r.colorDisabledDark};
          background-color: ${r.colorDisabledLight};
          border-color: ${r.colorDisabledMedium};
          opacity: ${r.opacitySemiOpaque};
        ` : o`
          &:hover {
            border-color: ${(t) => t.theme.colorNeutralDarkest};
          }
        `}


  ${({ isInvalid: e, theme: r }) => {
  const t = r.colorSupportNegativeMedium;
  return e && o`
        border-color: ${t};
        &:hover {
          border-color: ${t};
        }
        ${n} {
          color: ${t};
          &::placeholder {
            color: ${t};
          }
        }
        ${l} {
          color: ${t};
        }
      `;
}}

  ${({ isValid: e, theme: r }) => {
  const t = r.colorSupportPositiveMedium;
  return e && o`
        border-color: ${t};
        &:hover {
          border-color: ${t};
        }
        ${n} {
          color: ${t};
          &::placeholder {
            color: ${t};
          }
        }
        ${l} {
          color: ${t};
        }
      `;
}}
`;
export {
  h as I,
  l as a,
  n as b
};
